<template>
  <div v-if="isWifiConfigJson !== undefined">
    <OppleAbilityWifiJson
      v-if="isWifiConfigJson" 
      ref="OppleAbilityWifiJson"
      :item="item"
      :device="device"
      :action-list="actionList"
      @refreshWifi="refreshWifi"
    />
    <OppleAbilityWifi16
      v-else
      ref="OppleAbilityWifi16"
      :item="item"
      :device="device"
      :action-list="actionList"
    />
    <!-- <OppleAbilityWifi16Old
      v-else
      ref="OppleAbilityWifi16Old"
      :item="item"
      :device="device"
      :action-list="actionList"
    /> -->
  </div>
</template>

<script>
import OppleAbilityWifi16 from './OppleAbilityWifi_16.vue';
import OppleAbilityWifiJson from './OppleAbilityWifi_json.vue';
import { isWifiConfigJson } from './utils';

export default {
  components: {
    OppleAbilityWifi16,
    OppleAbilityWifiJson,
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
    actionList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isWifiConfigJson: undefined,
      isWifiConfig16: false
    }
  },

  computed: {
   
  },

  watch: {
   
  },

  mounted() {
    this.isWifiConfigJson = isWifiConfigJson(this.item);
  },
   
  methods: {
    refreshWifi() {
      this.$emit('refreshWifi')
    },
    validate() {
      if (this.isWifiConfigJson) {
        return this.$refs.OppleAbilityWifiJson.validate();
      }
      
      return this.$refs.OppleAbilityWifi16.validate();
    },
    getFormData() {
      if (this.isWifiConfigJson) {
        return this.$refs.OppleAbilityWifiJson.getFormData();
      }
      
      return this.$refs.OppleAbilityWifi16.getFormData();
    }
  },
};
</script>

<style lang="scss">

</style>
